// Team Cards Block - See More/Less functionality
function initTeamCards() {
    document.addEventListener('DOMContentLoaded', function() {
        const seeMoreButtons = document.querySelectorAll('.team-card-tile__see-more');
        
        seeMoreButtons.forEach(button => {
            button.addEventListener('click', function() {
                const cardTile = this.closest('.team-card-tile');
                const truncatedContent = cardTile.querySelector('.team-card-tile__content--truncated');
                const fullContent = cardTile.querySelector('.team-card-tile__content--full');
                
                if (truncatedContent && fullContent) {
                    // Check if currently showing truncated content
                    if (!fullContent.classList.contains('show')) {
                        // Show full content, hide truncated
                        truncatedContent.style.display = 'none';
                        fullContent.classList.add('show');
                        this.classList.add('expanded');
                    } else {
                        // Hide full content, show truncated
                        fullContent.classList.remove('show');
                        setTimeout(() => {
                            truncatedContent.style.display = 'block';
                        }, 400); // Wait for animation to complete
                        this.classList.remove('expanded');
                    }
                }
            });
        });
    });
}

initTeamCards();
